import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { ActivityFeedTime } from './acitivity-feed-time';
import { ChatActivityContainer } from './chat-activity-container';
import { StyledTypography } from './styled/typography.styled';

export const DeleteConversationLabelActivityMessage = ({
  activity,
}: {
  activity: ActivityFeed;
}) => {
  const labelName = activity.changes.find((c) => c.field === 'displayName')?.value;
  return (
    <ChatActivityContainer
      icon="label_off"
      title={
        <StyledTypography>
          <b>{activity.actor.name}</b> removed label &quot;<b>{labelName}</b>&quot;{' '}
          <ActivityFeedTime activity={activity} />
        </StyledTypography>
      }
    />
  );
};
